import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { TranscribeStreamingClient } from "@aws-sdk/client-transcribe-streaming";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";

import { viteEnv } from "utils/vite-env.util";

const REGION = "us-east-1";
const IDENTITY_POOL_ID = viteEnv.VITE_TRANSCRIBE_IDENTITY_POOL_ID || "";

const transcribeClient = new TranscribeStreamingClient({
  region: REGION,
  credentials: fromCognitoIdentityPool({
    client: new CognitoIdentityClient({ region: REGION }),
    identityPoolId: IDENTITY_POOL_ID
  })
});

export { transcribeClient };
